// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListService = Symbol('ListService');
